<template lang="html">
  <div>
    <nav class="main__menu__desktop" v-show="!ShowingNavMobile">
      <ul>
        <li class="has__subnav">
          <router-link to="/student/">
            <div class="has__subnav__icon">
              <DashboardIcon
                width="22px"
                height="22px"
                color="#6c6c6c"
              />
            </div>
            <span class="nav__text">
                Dashboard
            </span>
          </router-link>
        </li>
        <li class="has__subnav">
          <router-link to="/student/bookcoach">
            <div class="has__subnav__icon">
              <BookacoachIcon
                width="22px"
                height="22px"
                color="#6c6c6c"
              />
            </div>
            <span class="nav__text">
                Book a Coach
            </span>
          </router-link>
        </li>
        <li class="has__subnav">
          <router-link to="/student/studyprogressreport">
            <div class="has__subnav__icon">
              <StudydashIcon
                width="22px"
                height="22px"
                color="#6c6c6c"
              />
            </div>
            <span class="nav__text">
                Study Dashboard
            </span>
          </router-link>
        </li>
        <li class="has__subnav">
          <router-link to="/student/sessions">
            <div class="has__subnav__icon">
              <SessionsIcon
                width="22px"
                height="22px"
                color="#6c6c6c"
              />
            </div>
            <span class="nav__text">
                Sessions
            </span>
          </router-link>
        </li>
        <li class="has__subnav">
          <router-link to="/student/token">
            <div class="has__subnav__icon">
              <TokensIcon
                width="22px"
                height="22px"
                color="#6c6c6c"
              />
            </div>
            <span class="nav__text">
                Token
            </span>
          </router-link>
        </li>
        <li class="has__subnav" @click="getSessionSimulator">
          <router-link to="/student/#">
            <!-- <a href="https://tokbox.com/developer/tools/precall/" target="_blank"> -->
              <div class="has__subnav__icon">
                <SimulatorIcon
                  width="22px"
                  height="22px"
                  color="#6c6c6c"
                />
              </div>
              <span class="nav__text">
                  Session Simulator
              </span>
            <!-- </a> -->
          </router-link>
        </li>
      </ul>
    </nav>

    <nav class="main__menu__mobile" v-show="ShowingNavMobile">
      <v-toolbar-side-icon
        fixed
        top
        @click.stop="toggleShow">
      </v-toolbar-side-icon>

      <v-navigation-drawer
        v-model="isShowing"
        absolute
        temporary
        color="#1E263F"
      >
        <v-list class="pa-1">
          <v-list-tile>
              <v-list-tile-action>
                <DashboardIcon
                  width="22px"
                  height="22px"
                  color="#7E7E7E"
                />
              </v-list-tile-action>
              <v-list-tile-content>
                <router-link to="/student/">
                  <v-list-tile-title>Dashboard</v-list-tile-title>
                </router-link>
              </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
              <v-list-tile-action>
                <BookacoachIcon
                width="22px"
                height="22px"
                color="#7E7E7E"
                />
              </v-list-tile-action>
              <v-list-tile-content>
                <router-link to="/student/bookcoach">
                  <v-list-tile-title>Book a Coach</v-list-tile-title>
                </router-link>
              </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
              <v-list-tile-action>
                <StudydashIcon
                width="22px"
                height="22px"
                color="#7E7E7E"
                />
              </v-list-tile-action>
              <v-list-tile-content>
                <router-link to="/student/studyprogressreport">
                  <v-list-tile-title>Study Dashboard</v-list-tile-title>
                </router-link>
              </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
              <v-list-tile-action>
                <SessionsIcon
                width="22px"
                height="22px"
                color="#7E7E7E"
                />
              </v-list-tile-action>
              <v-list-tile-content>
                <router-link to="/student/sessions">
                  <v-list-tile-title>Sessions</v-list-tile-title>
                </router-link>
              </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
              <v-list-tile-action>
                <TokensIcon
                width="22px"
                height="22px"
                color="#7E7E7E"
                />
              </v-list-tile-action>
              <v-list-tile-content>
                <router-link to="/student/token">
                  <v-list-tile-title>Token</v-list-tile-title>
                </router-link>
              </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
              <v-list-tile-action>
                <SimulatorIcon
                width="22px"
                height="22px"
                color="#7E7E7E"
                />
              </v-list-tile-action>
              <v-list-tile-content>
                <router-link to="/student/#">
                  <!-- <a href="https://tokbox.com/developer/tools/precall/" target="_blank"> -->
                  <v-list-tile-title>Session Simulator</v-list-tile-title>
                  <!-- </a> -->
                </router-link>
              </v-list-tile-content>
          </v-list-tile>
        </v-list>

        <v-list class="pt-0" dense>
          <v-divider light></v-divider>

          <!-- <v-list-tile
            v-for="item in items"
            :key="item.title"
            @click=""
          >
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile> -->
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title>Account</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title>Setting</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title @click="onLogout">Sign Out</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>
    </nav>
  </div>
</template>

<script>
import DashboardIcon from '../../components/icons/DashboardIcon'
import BookacoachIcon from '../../components/icons/BookacoachIcon'
import StudydashIcon from '../../components/icons/StudydashIcon'
import SessionsIcon from '../../components/icons/SessionsIcon'
import TokensIcon from '../../components/icons/TokensIcon'
import SimulatorIcon from '../../components/icons/SimulatorIcon'

import { toggle } from '../../components/mixins/toggle.js'

export default {
  mixins: [toggle],
  components: {
    DashboardIcon,
    BookacoachIcon,
    StudydashIcon,
    SessionsIcon,
    TokensIcon,
    SimulatorIcon
  },
  data () {
    return {
      items: [
        { title: 'Dashboard', icon: 'dashboard' },
        { title: 'Book a Coach', icon: 'question_answer' },
        { title: 'Study Dashboard', icon: 'dashboard' },
        { title: 'Sessions', icon: 'question_answer' },
        { title: 'Tokens', icon: 'dashboard' },
        { title: 'Session Simulator', icon: 'question_answer' }
      ],
      mini: false,
      right: null,
      ShowingNavMobile: false,
      windowWidth:0,
      windowHeigt:0,
    }
  },
  mounted() {
     this.$nextTick( () => {
      window.addEventListener('resize', this.getWindowWidth);
      window.addEventListener('resize', this.getWindowHeight);

      this.getWindowWidth()
      this.getWindowHeight()
    })
  },
  methods: {
    getWindowWidth(event){
      this.windowWidth = document.documentElement.clientWidth;

      if (this.windowWidth <= 1023){
        //this for resolution ipad to mobile
        this.ShowingNavMobile = true
      }else if(this.windowWidth >= 1024){
        this.ShowingNavMobile = false
      }
    },

    getWindowHeight(event){
      this.windowHeigt = document.documentElement.clientHeight;
    },

    getSessionSimulator () {
      this.$store.dispatch("GET_SESSION_SIMULATOR")
    },
    onLogout() {
      this.$store.dispatch('LOGOUT')
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
    window.removeEventListener('resize', this.getWindowHeight);
  },
}
</script>

<style lang="scss">
  @import '../../views/content/Sidenav.scss';
</style>



// WEBPACK FOOTER //
// src/student-components/layout/Sidenav.vue